// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea501a32","453":"05d349ce","732":"1051df4b"}[chunkId] + ".chunk.js";
};